import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-boot-bridge",
  "aria-busy": "true",
  "aria-live": "polite"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login-card-wrapper" }
const _hoisted_6 = { class: "main-button-container" }
const _hoisted_7 = { class: "otp-hint" }
const _hoisted_8 = { class: "otp-boxes" }
const _hoisted_9 = ["autocomplete", "disabled", "value", "onInput", "onBeforeinput", "onKeydown"]
const _hoisted_10 = {
  key: 0,
  class: "otp-error"
}
const _hoisted_11 = { class: "main-button-container" }
const _hoisted_12 = { class: "otp-actions" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "main-button-container" }
const _hoisted_16 = { class: "signup-container" }
const _hoisted_17 = { class: "login-legal" }
const _hoisted_18 = { class: "login-legal-links" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "login-legal-payee" }
const _hoisted_21 = { class: "login-legal-payee-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.sessionRestoring)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.logoSrc,
              alt: "Liga",
              class: "login-boot-logo"
            }, null, 8, _hoisted_2),
            _createVNode(_component_ion_spinner, {
              name: "crescent",
              class: "login-boot-spinner"
            }),
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "login-boot-text" }, "Загрузка…", -1))
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_ion_content, {
        class: _normalizeClass('main-background'),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.logoSrc,
              alt: "liga-logo"
            }, null, 8, _hoisted_4)
          ], 512), [
            [_vShow, _ctx.showLogo]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ion_card, {
              class: _normalizeClass(['bg-transparent', _ctx.showLogo ? '' : 'half-screen-top'])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, { class: "ion-text-center white-bold" }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("АВТОРИЗАЦИЯ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    (_ctx.authMode === 'otp-email')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_ion_input, {
                            class: "login-field",
                            label: "Электронная почта",
                            "label-placement": "floating",
                            fill: "solid",
                            type: "email",
                            inputmode: "email",
                            modelValue: _ctx.loginData.username,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.username) = $event)),
                            disabled: _ctx.inlineLoading,
                            onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInputFocus())),
                            autocomplete: "email",
                            onKeyup: _withKeys(_ctx.requestOtp, ["enter"])
                          }, null, 8, ["modelValue", "disabled", "onKeyup"]),
                          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "otp-email-hint" }, "Код придёт на почту — и для нового адреса (это регистрация), и для уже существующего.", -1)),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_ion_button, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestOtp())),
                              disabled: _ctx.inlineLoading,
                              type: "submit"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("p", null, "Получить код", 512), [
                                  [_vShow, !_ctx.inlineLoading]
                                ]),
                                _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                                  [_vShow, _ctx.inlineLoading]
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _createElementVNode("div", {
                            class: "auth-switch",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.switchToPassword && _ctx.switchToPassword(...args)))
                          }, "Войти по паролю")
                        ], 64))
                      : (_ctx.authMode === 'otp-code')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("p", _hoisted_7, "Код отправлен на " + _toDisplayString(_ctx.loginData.username), 1),
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otpDigits, (_, idx) => {
                                return (_openBlock(), _createElementBlock("input", {
                                  key: idx,
                                  ref_for: true,
                                  ref: el => _ctx.setOtpRef(el, idx),
                                  class: "otp-box",
                                  type: "text",
                                  inputmode: "numeric",
                                  pattern: "[0-9]*",
                                  maxlength: "6",
                                  enterkeyhint: "done",
                                  autocomplete: idx === 0 ? 'one-time-code' : 'off',
                                  disabled: _ctx.inlineLoading,
                                  value: _ctx.otpDigits[idx],
                                  onInput: ($event: any) => (_ctx.onOtpInput(idx, $event)),
                                  onBeforeinput: ($event: any) => (_ctx.onOtpBeforeInput(idx, $event)),
                                  onKeydown: ($event: any) => (_ctx.onOtpKeydown(idx, $event)),
                                  onPaste: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOtpPaste && _ctx.onOtpPaste(...args))),
                                  onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputFocus()))
                                }, null, 40, _hoisted_9))
                              }), 128))
                            ]),
                            (_ctx.otpError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.otpError), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verifyOtp())),
                                disabled: _ctx.inlineLoading || !_ctx.otpComplete,
                                type: "submit"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("p", null, "Войти", 512), [
                                    [_vShow, !_ctx.inlineLoading]
                                  ]),
                                  _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                                    [_vShow, _ctx.inlineLoading]
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "auth-link-btn",
                                disabled: _ctx.inlineLoading || _ctx.resendSeconds > 0,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.requestOtp(true)))
                              }, _toDisplayString(_ctx.resendSeconds > 0 ? `Отправить снова (${_ctx.resendSeconds})` : 'Отправить снова'), 9, _hoisted_13),
                              _createElementVNode("button", {
                                type: "button",
                                class: "auth-link-btn",
                                disabled: _ctx.inlineLoading,
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.backToOtpEmail && _ctx.backToOtpEmail(...args)))
                              }, " Изменить email ", 8, _hoisted_14)
                            ]),
                            _createElementVNode("div", {
                              class: "auth-switch",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.switchToPassword && _ctx.switchToPassword(...args)))
                            }, "Войти по паролю")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_component_ion_input, {
                              class: "login-field",
                              label: "Логин (email)",
                              "label-placement": "floating",
                              fill: "solid",
                              type: "text",
                              modelValue: _ctx.loginData.username,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.loginData.username) = $event)),
                              disabled: _ctx.inlineLoading,
                              onIonFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onInputFocus())),
                              autocomplete: "username",
                              onKeyup: _withKeys(_ctx.singIn, ["enter"])
                            }, null, 8, ["modelValue", "disabled", "onKeyup"]),
                            _createVNode(_component_ion_input, {
                              class: "login-field",
                              label: "Пароль",
                              "label-placement": "floating",
                              fill: "solid",
                              type: "password",
                              modelValue: _ctx.loginData.password,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.loginData.password) = $event)),
                              disabled: _ctx.inlineLoading,
                              onIonFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputFocus())),
                              autocomplete: "current-password",
                              onKeyup: _withKeys(_ctx.singIn, ["enter"])
                            }, null, 8, ["modelValue", "disabled", "onKeyup"]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.singIn())),
                                disabled: _ctx.inlineLoading,
                                type: "submit"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("p", null, "Вход", 512), [
                                    [_vShow, !_ctx.inlineLoading]
                                  ]),
                                  _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                                    [_vShow, _ctx.inlineLoading]
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _createElementVNode("div", {
                              class: "auth-switch",
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.switchToOtpEmail && _ctx.switchToOtpEmail(...args)))
                            }, "Войти по коду из почты")
                          ], 64)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigate('signup')))
                      }, "Регистрация"),
                      _createElementVNode("div", {
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.navigate('reset-password')))
                      }, "Забыли пароль?")
                    ]),
                    _createElementVNode("div", {
                      class: "not-authorized",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.navigate('showcase')))
                    }, "Пропустить")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                href: _ctx.LEGAL.offerUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "login-legal-link"
              }, "Договор оферты", 8, _hoisted_19),
              _createElementVNode("span", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.navigate('privacy-policy'))),
                class: "login-legal-link"
              }, "Политика конфиденциальности"),
              _createElementVNode("span", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.navigate('offer-supplement'))),
                class: "login-legal-link"
              }, "Условия возврата")
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "login-legal-payee-title" }, "Платежи принимает:", -1)),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.LEGAL.payee.fullName), 1),
              _createElementVNode("p", null, "ИНН " + _toDisplayString(_ctx.LEGAL.payee.inn) + " · ОГРНИП " + _toDisplayString(_ctx.LEGAL.payee.ogrnip), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.LEGAL.payee.address), 1),
              _createElementVNode("p", null, "Тел.: " + _toDisplayString(_ctx.LEGAL.payee.phone) + " · " + _toDisplayString(_ctx.LEGAL.payee.email), 1)
            ])
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.authenticated && !_ctx.sessionRestoring]
      ])
    ]),
    _: 1
  }))
}